export default __webpack_public_path__ + "static/media/24.9c845a68.jpg";